import { render, staticRenderFns } from "./DetailChart.vue?vue&type=template&id=4feb92c3&"
import script from "./DetailChart.vue?vue&type=script&lang=js&"
export * from "./DetailChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports